import { Box, Button, FormLabel } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { FormikSwitch } from 'components/Formik';
import LogoLoader from 'components/Loader/LogoLoader';
import Title from 'components/Title';
import FEATURES from 'global/features';
import { routePaths } from 'global/routePaths';
import { useFetchSettings } from 'hooks/companySettings/useFetchSettings';
import { useSaveShortestDistance, ISaveShortestDistance } from 'hooks/companySettings/useSaveShortestDistanceSettings';
import { useFeatureList } from 'store/useFeatureStore';

import { intialReportData } from './schema';

const ShortestDistance: React.FC<unknown> = () => {
  const { t } = useTranslation(['common', 'companySettings']);

  const featureList = useFeatureList();
  const navigate = useNavigate();

  const { data, status, refetch } = useFetchSettings(
    featureList[FEATURES.suggested_mileage] ? 'shortest_distance' : ''
  );
  const { status: saveShortestDistanceStatus, mutateAsync } = useSaveShortestDistance();

  const handleFormSubmit = async (values: typeof intialReportData) => {
    const postData: ISaveShortestDistance = {
      should_allow_avoid_tolls: values.should_allow_avoid_tolls,
      should_always_find_shortest_distance: values.should_always_find_shortest_distance,
      always_report_shortest_distance: values.always_report_shortest_distance,
    };
    mutateAsync(postData).then(() => {
      refetch();
    });
  };

  useEffect(() => {
    if (!featureList[FEATURES.suggested_mileage]) {
      navigate(routePaths.companySettings.base.route);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const suggestedMileagePaywallData = {
  //   heading: 'Timeero Suggested Mileage Pro Feature',
  //   description: 'Take the stress out of scheduling and save on average 30 hours a week by using Timeero',
  //   learnMoreLink: 'https://timeero.com/pricing',
  //   upgradeLink: routePaths.accountBilling.upgrade,
  //   featureList: [
  //     'Simple, Powerful and Easy Schedule to Use',
  //     'Option to create and edit schedules in real-time',
  //     'Send notifications and schedule updates to your employees',
  //     'Eliminate schedule conflicts',
  //   ],
  //   heroImg: upsaleTemplate,
  //   isColumn: true,
  // };

  // if (featureList[FEATURES.suggested_mileage]) return <UpsaleTemplate {...suggestedMileagePaywallData} />;

  if (status === 'loading') return <LogoLoader />;

  return (
    <Box>
      <Box mb={{ base: '2', md: '0' }}>
        <Title>{t('companySettings:shortestDistance')}</Title>
      </Box>
      <Box mt="26px">
        <Formik initialValues={data?.payload || intialReportData} enableReinitialize onSubmit={handleFormSubmit}>
          {() => (
            <Form noValidate>
              <Box display="flex" flexDirection="column" maxWidth="390px">
                <Box display="flex" justifyContent="space-between" mb="17px">
                  <FormLabel fontSize="sm">{t('companySettings:avoidTolls')}</FormLabel>
                  <FormikSwitch name="should_allow_avoid_tolls"></FormikSwitch>
                </Box>
                <Box display="flex" justifyContent="space-between" mb="17px">
                  <FormLabel fontSize="sm">
                    {t('companySettings:automaticallyCalculateShortestRouteOnAllMilesTraveled')}
                  </FormLabel>
                  <FormikSwitch name="should_always_find_shortest_distance"></FormikSwitch>
                </Box>
                <Box display="flex" justifyContent="space-between" mb="17px">
                  <FormLabel fontSize="sm">
                    {t('companySettings:useTheShortestMileageOverActualDrivenMileage')}
                  </FormLabel>
                  <FormikSwitch name="always_report_shortest_distance"></FormikSwitch>
                </Box>
              </Box>
              <Button
                type="submit"
                colorScheme="secondary"
                isLoading={saveShortestDistanceStatus === 'loading'}
                minWidth="100px"
              >
                {t('common:save')}
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};
export default ShortestDistance;
